import styled from 'styled-components';

// TODO: Move styled fieldset and legend to Shrike
// https://arcadiapower.atlassian.net/browse/DASH-1388
export const StyledFieldset = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
`;

export const StyledLegend = styled.legend<StyleProps>`
  color: ${props => props.theme.colors.content[props.variant]};
  font-family: ${props => props.theme.fontFamilies.main.medium};
  -webkit-font-smoothing: antialiased;
  font-size: ${props => props.theme.fontSizes[props.fontSize]};
  line-height: ${props => props.theme.lineHeights.medium};
  opacity: ${props => props.theme.opacities[props.opacity]};
`;
